import { Card, Descriptions, Typography } from 'antd';
import React from 'react';
import { CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFieldsFragment } from '../../../../../../generated';
import { LegalCertification } from '../../../../../shared/legal_certification/legal-certification';

export interface ApplicantDetailsSummaryProps {
  applicationDetails: CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFieldsFragment;
}

export const ApplicantDetailsSummary: React.FC<ApplicantDetailsSummaryProps> = (props) => {
  return (
    <Card>
      <Typography.Text style={{ fontSize: '20px' }}>Applicant Provided Details</Typography.Text>
      <Descriptions layout="vertical" style={{ marginTop: 20 }} title={<Typography.Text style={{ fontSize: '16px' }}>Which Credential do you want to send?</Typography.Text>}>
        <Descriptions.Item contentStyle={{ paddingLeft: '18px' }}>
          <Typography.Text style={{ marginTop: -10 }}>{props.applicationDetails?.credentialTitle || 'N/A'}</Typography.Text>
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        layout="vertical"
        title={<Typography.Text style={{ fontSize: '16px' }}>Where do you want to send this Credential?</Typography.Text>}
        style={{ marginTop: 15 }}
      >
        <Descriptions.Item label="Institution Name" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.destinationName || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Institution Email" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.destinationEmail || 'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Institution Phone" labelStyle={{ marginTop: -10 }}>
          {props.applicationDetails?.destinationPhone || 'N/A'}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions style={{ marginTop: 20 }}>
        <Descriptions.Item label="">
          <LegalCertification />
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};
